<template>
  <div>
    <section class="quote bg-light py-5">
      <div class="container py-md-3" data-aos="fade-up">
        <h4>
          Nous transformons des idées en innovations technologiques, 
          offrant à nos clients le pouvoir de réaliser leur vision 
          numérique avec excellence.
        </h4>
        <div class="start text-right mt-4" data-aos="flip-left">
          <a href="#contact" @click="envoyer('Bonjour. Je vous écris pour exprimer mon intérêt pour vos services et pour obtenir davantage d\'informations à ce sujet. J\'ai parcouru votre site web et j\'aimerais en savoir plus sur ce que vous proposez.')" class="scroll">Nous joindre </a>
        </div>
        <div class="clearfix"></div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Quote-Item",
  methods: {
    envoyer(texte){
      this.$emit('prendre', texte);
    }
  },
};
</script>

<style lang="scss" scoped>
</style>